<sc-flex [formGroup]="formGroup">

  <sc-checkbox-field formControlName="checked" [label]="supplementaryEquipment.name"></sc-checkbox-field>
  @if (supplementaryEquipment.availableIdentifiers?.length > 0) {
    <sc-content-spacer></sc-content-spacer>
    <mat-form-field class="checkbox-value" appearance="fill">
      <mat-label>
        <sc-dictionary-label dictionaryKey="tmc-common.equipment.entity.equipment.identifier"></sc-dictionary-label>
      </mat-label>
      <mat-select name="identity" formControlName="identifier" [disabled]="supplementaryEquipment.selected === false" required="true">
        @for (identity of supplementaryEquipment.availableIdentifiers; track identity) {
          <mat-option [value]="identity">{{identity}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }


</sc-flex>
